import { API_CALL_SUCCESS } from '../constants/actionTypes';
import {
    ME,
} from '../constants/apiConstants';

const apiCurrentUsersReducer = (state, action) => {
    const {
        endpoint,
    } = action;

    switch (endpoint) {
    case ME:
        return action.response;
    default:
        return state;
    }
};

const initialState = {
};

export const isLoggedIn = () => {
    return global.drupalSettings.catalogues.is_admin || global.drupalSettings.catalogues.can_admin_updates;
};

export default (state = initialState, action) => {
    const {
        type,
    } = action;

    switch (type) {
    case API_CALL_SUCCESS:
        return apiCurrentUsersReducer(state, action);
    default:
        return state;
    }
};
